module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": _vm.banner
    }
  })]), _vm._v(" "), (_vm.homeLogoDisplay) ? _c('div', {
    staticClass: "partner"
  }, [(!_vm.hidePartnerLogo) ? _c('img', {
    attrs: {
      "src": _vm.wkbLogo
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.partnerLogo
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-575b5807"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductHeader.vue
// module id = 650
// module chunks = 1